import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as style from './timelineCountTrigger.module.scss';

const cheat = 75;

class TimelineCountTrigger extends Component {
  constructor() {
    super();
    this.state = {
      active: false,
    };
  }
  componentDidMount() {
    this.props.registerNodeListener(this.checkActive.bind(this));
  }
  checkActive(scrollHeight, windowHeight) {
    if (this.el) {
      const bottom = this.el.offsetTop + this.el.offsetHeight;
      const scrollMeasure = scrollHeight + windowHeight / 2;
      const inRange =
        scrollMeasure > this.el.offsetTop + cheat &&
        scrollMeasure < bottom - cheat;
      if (!this.state.active && inRange) {
        this.setState({
          active: true,
        });
        if (typeof this.props.updateCounts !== 'undefined') {
          this.props.updateCounts(this.props.bombCount);
        }
      } else if (this.state.active && !inRange) {
        this.setState({ active: false });
      }
    }
  }

  render() {
    return (
      <div
        ref={el => {
          this.el = el;
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

TimelineCountTrigger.propTypes = {
  scrollHeight: PropTypes.number,
  bombCount: PropTypes.string,
  updateCounts: PropTypes.func,
};

export default TimelineCountTrigger;
